export default {
    view_map: 'Посмотреть на карте',
    no_offers: 'У этой компании нет услуг.',
    no_offers_user: 'У этого пользователя нет услуг.',
    no_results: 'Результаты не найдены!',
}
